import { render } from "./ConfirmProperty.vue?vue&type=template&id=927737bc"
import script from "./ConfirmProperty.vue?vue&type=script&lang=js"
export * from "./ConfirmProperty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__